import { render, staticRenderFns } from "./LoginPageGoogle.vue?vue&type=template&id=48a2f5c2&scoped=true&"
import script from "./LoginPageGoogle.vue?vue&type=script&lang=js&"
export * from "./LoginPageGoogle.vue?vue&type=script&lang=js&"
import style0 from "./LoginPageGoogle.vue?vue&type=style&index=0&id=48a2f5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2f5c2",
  null
  
)

export default component.exports